<template>
  <v-dialog :fullscreen="true" v-model="showSelectionView" transition="fade-transition">
    <v-sheet>
      <v-container :fluid="true" style="height: 100vh" class="pa-0">
        <v-row style="height: 100%" class="ma-0">
          <v-col :cols="isPortrait ? '12' : '8'" id="cover-image" :order="isPortrait ? '0' : '5'" class="pa-0 cover-image">
            <v-img
              :lazy-src="organizationCoverImage('thumbnail')"
              :src="organizationCoverImage('original')"
              :cover="true"
              class="bg-primary cover-image"
            />
          </v-col>
          <v-col :cols="isPortrait ? '12' : '4'" :order="isPortrait ? '5' : '0'" class="d-flex flex-column justify-space-between px-0 py-5">
            <div v-if="(isPortrait && !isKioskMini && $vuetify.display.height < 1200) || !isPortrait" style="height: 4rem" />
            <PackagingSelection />
            <LanguageSelection />
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
  </v-dialog>
</template>

<script>
import { useI18n } from 'vue-i18n'
import LanguageSelection from '../components/common/LanguageSelection.vue'
import PackagingSelection from '../components/packaging/PackagingSelection.vue'
import { useStore } from '../stores/store'

export default {
  name: 'LocationPackagingSelectionView',
  components: {
    PackagingSelection,
    LanguageSelection,
  },
  setup() {
    const store = useStore()
    const { t, te } = useI18n()

    return {
      store,
      t,
      te,
    }
  },
  data() {
    return {
      showSelectionView: false,
      selecting: false,
    }
  },
  watch: {
    shouldShow: {
      handler(newValue) {
        console.info('[LocationPackagingSelectionView.vue] shouldShow watcher triggered:', newValue)
        this.showSelectionView = newValue
      },
      immediate: true
    },
  },
  computed: {
    allowedLanguages() {
      try {
        const languages = this.store.kiosk.allowedLanguages
        if (Array.isArray(languages)) {
          if (!languages.includes(this.defaultLanguage)) {
            return [this.defaultLanguage, ...languages]
          }
        }
        return this.store.kiosk.allowedLanguages
      } catch (e) {
        return []
      }
    },
    isPortrait() {
      return this.$vuetify.display.height >= this.$vuetify.display.width
    },
    isKioskMini() {
      return this.$vuetify.display.mobile
    },
    isLandscape() {
      return this.store.isLandscape
    },
    selectedLocationPackagingType() {
      if (this.store.order) {
        return this.store.order.selectedLocationPackagingType
      }
      return null
    },
    shouldShow() {
      // Don't show during initial setup or when getting initial data
      if (this.store.gettingInitialData || this.store.showInitialSetupScreen) {
        return false
      }      
      return this.selectedLocation && !this.selectedLocationPackagingType && this.showPackagingOptions
    },
    showPackagingOptions() {
      return this.store.showPackagingOptions
    },
    displayScaleFactor() {
      return this.store.getDisplayScale(window.innerWidth)
    },
    packagingTypes() {
      return this.store.packagingTypes
    },
    order() {
      return this.store.order
    },
    selectedLocation() {
      if (this.order) {
        return this.order.selectedLocation
      }
      return null
    },
    kiosk() {
      return this.store.kiosk
    },
    locations() {
      if (typeof this.kiosk !== 'undefined' && this.kiosk !== null) {
        return this.kiosk.locations
      }
      return []
    },
    showBackButton() {
      return Array.isArray(this.locations) && this.locations.length > 1
    },
    selectedLocationLabel() {
      if (typeof this.selectedLocation !== 'undefined' && this.selectedLocation !== null) {
        return this.selectedLocation.label
      }
      return ''
    },
    organization() {
      if (typeof this.kiosk !== 'undefined' && this.kiosk !== null) {
        return this.kiosk.organization
      }
      return null
    },
  },
  methods: {
    displayScaleFactorNumber(number) {
      return this.store.getDisplayScaledNumber(this.getDisplayScale, number)
    },
    selectPackagingType(type) {
      this.selecting = true
      setTimeout(() => {
        this.store.updateSessionStartTime()
        this.store.selectPackaging(type)
        this.selecting = false
      }, 100)
      this.store.customLogger('info', 'Selected Order Fulfillment', type)
    },
    back() {
      try {
        this.store.order.selectedLocation = null
      } catch (e) {
        //
      }
    },
    organizationImage(size = 'large') {
      if (typeof this.organization !== 'undefined' && this.organization !== null) {
        if (typeof this.organization.logo !== 'undefined' && this.organization.logo !== null) {
          if (typeof this.organization.logo.file !== 'undefined' && this.organization.logo.file !== null) {
            if (typeof this.organization.logo.file.sources !== 'undefined' && this.organization.logo.file.sources !== null) {
              if (typeof this.organization.logo.file.sources[size] !== 'undefined' && this.organization.logo.file.sources[size] !== null) {
                return this.organization.logo.file.sources[size]
              }
            }
          }
        }
      }
      return ''
    },
    locationImage(size = 'large') {
      if (typeof this.selectedLocation !== 'undefined' && this.selectedLocation !== null) {
        let locationImage = null
        if (typeof this.selectedLocation.logo !== 'undefined' && this.selectedLocation.logo !== null) {
          locationImage = this.selectedLocation.logo
        } else if (typeof this.selectedLocation.image !== 'undefined' && this.selectedLocation.image !== null) {
          locationImage = this.selectedLocation.image
        }
        if (typeof locationImage !== 'undefined' && locationImage !== null) {
          if (typeof locationImage.file !== 'undefined' && locationImage.file !== null) {
            if (typeof locationImage.file.sources !== 'undefined' && locationImage.file.sources !== null) {
              if (typeof locationImage.file.sources[size] !== 'undefined' && locationImage.file.sources[size] !== null) {
                return locationImage.file.sources[size]
              }
            }
          }
        }
        if (this.organizationImage(size)) {
          return this.organizationImage(size)
        }
      }
      return ''
    },
    organizationCoverImage(size = 'large') {
      if (typeof this.organization !== 'undefined' && this.organization !== null) {
        return this.store.displayImage(this.organization.cover, size)
      }
      return ''
    },
  },
}
</script>

<style scoped>
.front-page-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  justify-content: space-around;
  background-color: #f8f8f8;
}
@media (orientation: landscape) {
  .cover-image {
    height: 100vh;
  }
}
@media (min-width: 721px) and (orientation: portrait) {
  .cover-image {
    height: 70vh;
  }
}
@media (max-width: 720px) and (orientation: portrait) {
  .cover-image {
    height: 65vh;
  }
}
</style>
